module.exports = __webpack_public_path__ + "img/product-preview-33.9df95fa.png";